module.exports = __webpack_public_path__ + "img/sel_Shenzhen-.81188b4c.png";